module.exports = __webpack_public_path__ + "img/ic_question_big.f0748155.png";